<div class="toaster">
  <article class="toast" *ngFor="let toast of toasts">
    <div class="toast__progress-bar"></div>
    <div class="toast__icon"></div>
    <div class="toast__content">
      <p class="toast__type">Success</p>
      <p class="toast__message" [innerHTML]="toast.message"></p>
    </div>
    <button class="toast__close" (click)="closeToast(toast.id)">⨉</button>
  </article>
</div>
